import React from 'react';
import PropTypes from 'prop-types';

const StoreShoppingCategories = ({
  hasShopYourLocalStore,
  isOutlet,
  firstShopLinkText,
  firstShopLinkUrl,
  secondShopLinkText,
  secondShopLinkUrl,
  isStoreIdEqualToOnlineStoreId,
  brandFromAPI,
  shopThisStoreOnlineText,
}) => {
  let linksToDisplay = null;
  if (isStoreIdEqualToOnlineStoreId) {
    if (hasShopYourLocalStore === '1' && !isOutlet) {
      linksToDisplay = (
        <div>
          <div className="hr" />
          <div className={`single-store__button-wrap ${brandFromAPI}`}>
            <h3>{shopThisStoreOnlineText.value}</h3>
            <div>
              <a
                className="link-as-tertiary-dark-button"
                href={firstShopLinkUrl}
                title={firstShopLinkText.value}
                data-property={firstShopLinkText.key}
              >
                {firstShopLinkText.value}
              </a>
              <a
                className="link-as-tertiary-dark-button"
                href={secondShopLinkUrl}
                title={secondShopLinkText.value}
                data-property={secondShopLinkText.key}
              >
                {secondShopLinkText.value}
              </a>
            </div>
          </div>
          <div className="hr" />
        </div>
      );
    }
  }
  return linksToDisplay;
};

StoreShoppingCategories.propTypes = {
  hasShopYourLocalStore: PropTypes.string.isRequired,
  isOutlet: PropTypes.bool.isRequired,
  firstShopLinkText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  firstShopLinkUrl: PropTypes.string.isRequired,
  secondShopLinkText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  secondShopLinkUrl: PropTypes.string.isRequired,
  isStoreIdEqualToOnlineStoreId: PropTypes.bool.isRequired,
  brandFromAPI: PropTypes.string.isRequired,
  shopThisStoreOnlineText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
};

export default StoreShoppingCategories;
